export const ScrollIds = {
    advancedSettings: 'advanced-settings-section',
    credits: 'credits-section',
    payment: 'payment-section',
};
